export const EXTERNAL_SYSTEMS_LOADED_SUCCESS = 'EXTERNAL_SYSTEMS_LOADED_SUCCESS';
export const EXTERNAL_SYSTEMS_LOADED_FAILED = 'EXTERNAL_SYSTEMS_LOADED_FAILED';
export const USER_SELECTED_EXTERNAL_SYSTEM = 'USER_SELECTED_EXTERNAL_SYSTEM';
